<header class="header">
  <app-navbar
    [startPageUrl]="startPageUrl"
    [showPauseActionWithinTask]="false"
    logoUrl="assets/logo.svg"
  />
</header>
